import type { ReactNode } from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./Shortlist.scss";

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  footer?: ReactNode;
  children: ReactNode;
}

function SidePanel({ open, title, onClose, footer = null, children }: Props) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} slotProps={{ paper: { className: "sl-panel" } }}>
      <div className="sl-panel__head">
        <h2>{title}</h2>
        <IconButton aria-label="Close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div className="sl-panel__body">{children}</div>
      {footer && <div className="sl-panel__foot">{footer}</div>}
    </Drawer>
  );
}

export default SidePanel;
